module.exports = __webpack_public_path__ + "static/media/battery-bolt.2678713a.svg";